import { Checkbox, FormControlLabel, Grid, Stack, Typography } from "@mui/material";
import React from "react";
import { IControlledMutator, IOptions } from "sonobello.utilities.react";

import { AreaOfInterest } from "../Types/AreaOfInterest";

export const classNames = {
  control: "areasOfInterestPickerControl",
  label: "areasOfInterestPickerLabel"
};

export interface IAreasOfInterestPickerProps
  extends IControlledMutator<Record<string, boolean>>,
    IOptions<AreaOfInterest> {
  /** The label to be shown at the top of the component.
   * @remarks This usually summarizes the type of areas shown by the filter.
   */
  label: string;
  /** If provided, limits the rendered area options to only those fulfilling the filter predicate. */
  filter: ((aoe: AreaOfInterest) => boolean) | null;
}

/** A form element which allows for the selection of multiple areas of interest. */
const AreasOfInterestPicker: React.FC<IAreasOfInterestPickerProps> = ({ value, label, options, filter, onChange }) => (
  <Stack spacing={1}>
    <Typography variant="stageDirection" className={classNames.label}>
      {label}
    </Typography>
    <Grid container spacing={2} direction="row" justifyContent="space-evenly">
      {options.map(
        (option, index) =>
          (!filter || filter(option)) && (
            <Grid item key={index}>
              <FormControlLabel
                className={classNames.control}
                label={option.name}
                checked={value[option.id] || false}
                onChange={(_, checked) => onChange({ ...value, [option.id]: checked })}
                control={<Checkbox />}
              />
            </Grid>
          )
      )}
    </Grid>
  </Stack>
);

export default AreasOfInterestPicker;
